import { getLocationFromFlowAPI } from '../contexts/Location/locationProviderPropsMap';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

export const isBMPreview = (flowAPI: ControllerFlowAPI) => {
  const query = getLocationFromFlowAPI(flowAPI).query;
  return !!query?.forcedPreviewAs && !!query?.instance;
};
